// extracted by mini-css-extract-plugin
export default {"appsSection":"Apps_appsSection__fNdZ6","container":"Apps_container__5HE79","sectionTitle":"Apps_sectionTitle__ajM+U","intro":"Apps_intro__oqJ-P"};